// frontend/src/data/majors.js
export const MAJORS = [
  "Not Listed / Other Major",
  "Accounting",
  "Actuarial Science",
  "Biochemistry",
  "Biology",
  "Biomedical Science",
  "Biotechnology",
  "Business & Society",
  "Business Administration",
  "Business Economics",
  "Chemistry",
  "Children, Childhood and Youth",
  "Cinema & Media Arts",
  "Cities, Regions, Planning",
  "Civil Engineering",
  "Cognitive Science",
  "Commerce",
  "Communication & Media Studies",
  "Communication, Social Media & Public Relations",
  "Computer Engineering",
  "Computer Science",
  "Computer Security",
  "Creative Writing",
  "Criminology",
  "Dance",
  "Data Science",
  "Design",
  "Digital Media",
  "Digital Technologies",
  "Disaster & Emergency Management",
  "Earth & Atmospheric Science",
  "Economics",
  "Educational Studies",
  "Electrical Engineering",
  "Engineering",
  "Engineering & International Development Studies",
  "English",
  "English & Professional Writing",
  "Entrepreneurship and Innovation",
  "Environmental Arts and Justice",
  "Environmental Biology",
  "Environmental Science",
  "Ethics and Political Philosophy",
  "Financial & Business Economics",
  "Financial Technologies",
  "French Studies",
  "Gender, Sexuality and Women's Studies",
  "Geomatics Engineering",
  "Global Geography",
  "Global Health",
  "Global History and Justice",
  "Global Political Studies",
  "Health & Society",
  "Health Policy, Management & Digital Health",
  "Health Studies",
  "History",
  "Human Resource Management",
  "Human Rights & Equity Studies",
  "Humanities",
  "Indigenous Studies",
  "Individualized Studies",
  "Information Technology",
  "Integrative Arts",
  "Interdisciplinary Social Science",
  "International Development Studies",
  "International Studies",
  "Italian Studies",
  "Kinesiology & Health Science",
  "Law & Society",
  "Linguistics",
  "Linguistics, Language and Society",
  "Mathematics",
  "Mathematics for Education",
  "Mechanical Engineering",
  "Mechatronics Engineering",
  "Music",
  "Neuroscience",
  "Nursing",
  "Philosophy",
  "Physics & Astronomy",
  "Political Science",
  "Professional Translation",
  "Professional Writing",
  "Psychology",
  "Public Administration",
  "Science, Technology and Society",
  "Social Work",
  "Statistics",
  "Sustainable Environmental Management",
  "Theatre",
  "Visual Arts – Art History",
  "Visual Arts – Studio",
  "Work & Labour Studies",
  "Undecided / Undeclared Major",
];
